import React from 'react';
import moment from "moment/moment";

import {renderLocalDateFromUtcDate} from '../services/DateModule';

export const ReplenishmentItem = (props) => {

    const ExportItem = (props) => {
        return (
            <li style={{listStyleType: 'none'}}>
                {moment.utc(props.exportedAt).local().format('DD.MM.YYYY HH:mm')}
            </li>
        )
    };

    const renderActions = () => {
        if (!props.canceled && !props.shipped) {
            return (
                <div>
                    <button className="btn btn-primary" onClick={() => props.markReplenishmentAsShipped(props.id)}
                            title="Versand bestätigen">
                        <i className="fa fa-truck"></i>
                    </button>
                </div>
            );
        }

        if (!props.canceled && props.shipped) {
            return (
                <div>
                    <button className="btn btn-danger" onClick={() => props.markReplenishmentAsUnshipped(props.id)}
                            title="Versand stornieren">
                        <i className="fa fa-truck"></i>
                    </button>
                </div>
            );
        }

        if (props.canceled) {
            return (
                <div>
                    <button className="btn btn-primary" onClick={() => props.restoreReplenishment(props.id)}
                            title="wiederherstellen">
                        <i className="fa fa-undo"></i>
                    </button>
                </div>
            );
        }
    };

    const renderCreatedAt = () => {
        return renderLocalDateFromUtcDate(props.createdAt);
    };

    const renderShippedAt = () => {
        if (moment.utc(props.shippedAt).isValid()) {
            return renderLocalDateFromUtcDate(props.shippedAt)
        }
    };

    const renderLastStockUpdate = () => {
        if (moment.utc(props.lastStockInStoreUpdateOnRelease).isValid()) {

            const lastStockUpdateAt = renderLocalDateFromUtcDate(props.lastStockInStoreUpdateOnRelease);

            return (
                <span>
                    {props.stockQuantityInStoreOnRelease}<br/>{lastStockUpdateAt}
            </span>
            )
        }
    };

    return (
        <tr>
            <td>{props.id}</td>
            <td style={{textAlign: 'right'}}>{props.quantity}</td>
            <td>{renderCreatedAt()}</td>
            <td>
                <ul style={{padding: '0'}}>
                    {props.replenishmentExports.map((exportItem) => <ExportItem {...exportItem}
                                                                                key={exportItem.exportedAt}/>)}
                </ul>
            </td>
            <td>{props.store.retailer.gln}<br/>{props.store.gln}</td>
            <td>{props.store.zipCode}<br/>{props.store.city}</td>
            <td>{props.module.name}</td>
            <td>{props.article.erpIdno}<br/>{props.article.gtin}<br/>{props.article.name}</td>
            <td>{props.article.vendorArticleNumber}</td>
            <td>{props.processingStatus}</td>
            <td>{renderShippedAt()}</td>
            <td>{renderLastStockUpdate()}</td>
            <td>
                {renderActions()}
            </td>
        </tr>
    )
};

export default ReplenishmentItem;



// WEBPACK FOOTER //
// ./src/admin/replenishment/ReplenishmentItem.js